import styled from 'styled-components';
import { Button } from '../../../navigation/buttons/Button/Button.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { Typography } from '../../../foundation/Typography/styled.js';

var StyledButton = styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "sc-1vzsj1-0"
})(["padding:0;margin:0;height:auto;"]);
var HeaderTextContainer = styled.div.withConfig({
  displayName: "HeaderTextContainer",
  componentId: "sc-1vzsj1-1"
})(["white-space:nowrap;padding:", ";display:flex;align-items:center;gap:", ";"], themeGet('spacing.sm'), themeGet('spacing.sm'));
var HeaderText = styled(Typography).attrs({
  $appearance: '100',
  $fontSize: 'small',
  $fontWeight: 'extrabold'
}).withConfig({
  displayName: "HeaderText",
  componentId: "sc-1vzsj1-2"
})([""]);

export { HeaderText, HeaderTextContainer, StyledButton };
